import './components/burger.js';
import './components/modal.js';
import './components/cookie.js';
import './components/form.js';
import './components/scroll-btn.js';
import './components/tabs.js';
import './components/slider.js';
import './components/video.js';
import './components/gallery.js';
import './components/steps.js';
import './components/dropdown.js';
import './components/toggle-btn.js';
